import type { MeQuery } from '#/__generated__/graphql/graphql';
import { createContext, useContext } from 'react';

export type User = MeQuery['me'];

export const UserContext = createContext<User | null>(null);

export function useUser() {
  const value = useContext(UserContext);

  if (!value) {
    throw new Error('useUser must be used within the PrivateRouteGuard or AdminRouteGuard');
  }

  return value;
}
